import React, {  Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { routes } from '../../redux/api/routes';

class ReplaceProductOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			replaceWith: 'other',
			errorMessage: ''
        }
    }
    closeDialog(event) {
        event && event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ReplaceProductOverlayDialog');
		this.props.resetSelectedSKU && this.props.resetSelectedSKU();
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
	// format up to 2 decimal
    formatNumber2Decimal(number) {
        number = (number)?number.trim().replace(/,/g,""):number;
        if(number) {
            number = number.replace("$","");
            number = "$"+parseFloat(number).toFixed(2);
            return number === "$0.00"?"--":number;
        } else {
            return "--";
        }
    }
	handleChangeReplacementOption(event) {
		this.setState({
			replaceWith: event.target.value,
			errorMessage: ''
		})
	}
	handleReplace(event) {
		event.preventDefault();
		if(this.state.replaceWith === '') {
			this.setState({
				errorMessage: 'Please select replacement product.'
			})
		} else {
			this.props.handleReplace(this.state.replaceWith);
		}
	}
	checkETA(eta, firstDistributionDate) {
		// If FDD is available and its greater than today's date then only we will check further
		if(firstDistributionDate && moment(firstDistributionDate).isAfter(moment())) {
			// if there is no existing eta OR
			// If the FDD for any model is greater than the ETA, show FDD.
			if(!eta || moment(firstDistributionDate).isAfter(moment(eta))) {
				eta = moment(firstDistributionDate).format('MM/DD/YYYY');
			}
		}
		// If the ETA for any model is > sysdate+365 days, show NA in the ETA field.
		if(eta && moment(eta).isAfter(moment().add(routes.horizon, "days"))) {
			eta = '6+ mos';
		}
		return eta;
	}

	validateFP(item) {
		const self = this;
		 let finalProductionDate = null;
		 if(item.geego_final_production_date && item.geego_final_production_date !== 'NULL') {
		 	finalProductionDate = item.geego_final_production_date;
		 }
		return self.checkIfFPExceptAvailability({
			finalProductionDate: finalProductionDate,
			etaDate: item.eta
		});
	}

	checkIfFPExceptAvailability(item) {
		let flag = false;
		if(moment(item.finalProductionDate).isSameOrBefore(moment().hours(0).minutes(0).seconds(0).milliseconds(0)) &&
			moment(item.etaDate).isAfter(moment().add(routes.horizon, "days").hours(0).minutes(0).seconds(0).milliseconds(0))
		) {
			flag = true;
		}
		return flag;
	}
    render() {
		let { replacementSKUData } = this.props;
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="replaceProductOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Replace Product</h2>
                    <p>Replacements for: <b>{replacementSKUData.replacingTo.item}</b></p>
					<p className="bold red">{this.state.errorMessage}</p>
					{replacementSKUData && replacementSKUData.replacingBy
	                    ? <form className="replaceProductForm" id="replaceProductForm" name="replaceProductForm" action="">
	                        <table className="dataTableType2 replaceProductTable">
	                            <thead>
	                                <tr>
	                                    <th className="product">
	                                        Product
	                                    </th>
	                                    <th className="availability">
	                                        Availability
	                                    </th>
	                                    <th className="eta">
	                                        ETA
	                                    </th>
	                                    <th className="price">
	                                        Price <span className="unbold">(Each)</span>
	                                    </th>
	                                    <th className="select">
	                                        Select
	                                    </th>
	                                  </tr>
	                            </thead>
	                            <tbody>
									{replacementSKUData.replacingTo
										?<tr>
		                                    <td className="product">
		                                        <b>{replacementSKUData.replacingTo.item}</b><br />
		                                        {replacementSKUData.replacingTo.itemDescription}
		                                    </td>
		                                    <td className="availability">
		                                        {replacementSKUData.replacingTo.availability}
		                                    </td>
		                                    <td className="eta">
												{this.validateFP(replacementSKUData.replacingTo)? 'FP':this.checkETA(replacementSKUData.replacingTo.eta, replacementSKUData.replacingTo.geego_distribution_start_date) }	
		                                    </td>
		                                    <td className="price">
												{this.formatNumber2Decimal(replacementSKUData.replacingTo.originalPrice)}
		                                    </td>
		                                    <td className="select">
		                                        <input type="radio" onClick={this.handleChangeReplacementOption.bind(this)} name="replace_XXXXXXXXXXX" defaultValue='same' defaultChecked={this.state.replaceWith === 'same'?true:false} />
		                                    </td>
		                                </tr>
										:null
									}
	                                <tr>
	                                    <td colSpan={5} className="replacedBy">
	                                        <span className="replacedByText">Replaced By</span>
	                                    </td>
	                                </tr>
									{replacementSKUData.replacingBy
										?<tr>
		                                    <td className="product">
		                                        <b>{replacementSKUData.replacingBy.item}</b><br />
		                                        {replacementSKUData.replacingBy.itemDescription}
		                                    </td>
		                                    <td className="availability">
		                                        {replacementSKUData.replacingBy.availability}
		                                    </td>
		                                    <td className="eta">
												{this.validateFP(replacementSKUData.replacingBy)? 'FP':this.checkETA(replacementSKUData.replacingBy.eta, replacementSKUData.replacingBy.geego_distribution_start_date) }
		                                    </td>
		                                    <td className="price">
		                                        {this.formatNumber2Decimal(replacementSKUData.replacingBy.originalPrice)}
		                                    </td>
		                                    <td className="select">
		                                        <input type="radio" onClick={this.handleChangeReplacementOption.bind(this)} name="replace_XXXXXXXXXXX" defaultValue="other" defaultChecked={this.state.replaceWith === 'other'?true:false} />
		                                    </td>
		                                </tr>
										:null
									}
	                            </tbody>
	                        </table>
	                        <div className="noButtonContainer">
	    						<a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
	    					</div>
	    					<div className="yesButtonContainer">
	    						<a className="blueButton yesButton" onClick={this.handleReplace.bind(this)}>Replace</a>
	    					</div>
	                    </form>
						: <p className="bold red">No replacement available for this item.</p>
					}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
   return {state};
};
ReplaceProductOverlayDialog = connect(mapStateToProps)(ReplaceProductOverlayDialog);
export default ReplaceProductOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/replaceProductOverlayDialog.js